export const siteLinkClassNames = 'text-base font-bold cursor-pointer';
export const categoryLinkClassNames = 'text-gray-66 text-lg leading-4 font-bold cursor-pointer';
